/**
 * ⚠️  AUTO-GENERATED FILE - DO NOT EDIT MANUALLY ⚠️
 *
 * This file is generated by generate-feature-flags.ts from feature-flags-registry.json.
 * To add or modify feature flags, edit feature-flags-registry.json and run: npm run generate:feature-flags
 *
 * @generated
 * @hash 78e25bab93e7b012
 */

const AnalyticsFlags = [
  'experienceHasPerformanceMonitoringAccess',
  'userCanViewAnalyticsForUniverse',
  'experienceHasExperimentationMinDau',
  'experienceHasNoInGameExperiment',
  // should only be used for unit tests
  'flagForUnitTest',
  // determines whether the 'override control' is visible & enabled
  'flagRuntimeOverrideControlEnabled',
  'sentryChartTracingEnabled',
  'acquisitionMigrationMetricsEnabled',
  'exploreModeDateRangeFromChartContextEnabled',
  // Display a simplified table showing only asset IDs when user has access to personalization data. Purpose: Enables moderators to identify and collect asset IDs of thumbnails targeted for removal. Context: Implementation related to content moderation incident - see detailed documentation: https://docs.google.com/document/d/1ZoBRM2ivcPZBnkzbVYKEEiDb0XcoPKuG5lrDM6N5Gcg/edit?tab=t.0
  'visibleAssetIdInPersonalizationEnabled',
  'shareLinkAcquisitionTableEnabled',
  'ugcItemAnalyticsEnabled',
  'remoteConfigsEnabled',
  'isTargetingConfigsEnabled',
  'studioConfigsEnabled',
  'IsGeneralBreakGlassBannerEnabled',
  'IsMonetizationBreakGlassBannerEnabled',
  'isPlayerFeedbackExampleCommentsEnabled',
  'isAnalyticsAssistantChatEnabled',
  'isAnalyticsAssistantIssueBannerEnabled',
  'showCreatorRewardsReportingDisclaimer',
  'isGamePreviewVideoUploadEnabled',
  'studioWithoutThemeModeProviderEnabled',
  'showSpeechToTextDashboard',
  'showTextToSpeechDashboard',
  'isClientScriptCPUTimeEnabled',
  'isYoutubeVideoThumbnailUpload5MinPollingEnabled',
  'isYoutubeVideoThumbnailUpload15MinPollingEnabled',
  'isYoutubeVideoThumbnailUpload30MinPollingEnabled',
  'isYoutubeVideoThumbnailUpload60MinPollingEnabled',
  'isRotraceMetricEnabled',
  'showHttpServiceDashboard',
  'showMessagingServiceDashboard',
  'recommendationServiceEnabled',
  // Enables the Recommendation Service configuration pages and tab
  'recommendationServicesConfigEnabled',
  'allowNewChipOnNavigationEnabled',
  'isGamePassBonusPromotionsTableEnabled',
  'isEngineReleaseAnnotationEnabled',
  'isMetricsSummaryInsightEnabled',
  'isNewSignalCountInReportCardEnabled',
  'isServerShutdownChartEnabled',
  'isCrashesPageEnabled',
  'isOverviewUnifiedAlertBannerEnabled',
  'isTreemapColorBySiblingProportionEnabled',
  'isCreatorRewardsBenchmarksEnabled',
  'isDeepPlayEnabled',
  'isExploreModeSidebarLayoutEnabled',
  // Enables Explore Mode computed metrics features (operations/equation builder and computed metric query-param interpretation). Depends on isExploreModeSidebarLayoutEnabled being enabled.
  'isExploreModeComputedMetricsEnabled',
  // Enables Explore Mode chart type selection controls. Depends on isExploreModeSidebarLayoutEnabled being enabled.
  'isExploreModeChartTypeSelectionEnabled',
  // Enables the Explore Mode Table option in chart type selection. Depends on isExploreModeSidebarLayoutEnabled and isExploreModeChartTypeSelectionEnabled being enabled.
  'isExploreModeTableChartTypeEnabled',
  // Enables Explore Mode L7 smoothing controls and behavior. Depends on isExploreModeSidebarLayoutEnabled being enabled.
  'isExploreModeL7SmoothingEnabled',
  // Enables Explore Mode trend line overlay option and rendering. Depends on isExploreModeSidebarLayoutEnabled being enabled.
  'isExploreModeTrendLineOverlayEnabled',
  // Enables consistent breakdown coloring across charts on the same page
  'isBreakdownColorConsistencyEnabled',
  'isExperienceAlertsEnabled',
  'isRetentionCheckEnabled',
  'isNewRFYSignalsEnabled',
  'isGetMostRecentInsightsEnabled',
  'isHistoricalSummaryReportInsightsEnabled',
  'isAssistantInlineLayoutEnabled',
] as const;

export default AnalyticsFlags;
